import React, { useState } from "react";
import { IStaffConnectCompose } from "../../../models/dashboard/staffConnect/staffConnect";
import { connect } from "react-redux";
import { ISendMail } from "../../../models/common/IUserProfile";
import { createFeedback } from "../../../action/common/commonActionCreator";
import SweetAlert from "react-bootstrap-sweetalert";
import { getAlertData } from "../../../helper/sweet-alert";
import LoaderSpinner from "../../../common-components/loader";
import { baseURL } from "../../../constants/commonConstants";
import { mailValidation } from "../../../common-functions/commonFunctions";

const StaffConnectCompose = (props: IStaffConnectCompose) => {
  const { setShowStaffConnectCompose, SendMail, staffConnect, user } = props;

  const handleClose = () => setShowStaffConnectCompose(false);
  const [content, setContent] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const handleSendMail = () => {

    let alertData = mailValidation(subject,content,[staffConnect?.emailId ?? ""])
        if (alertData) {
          setShowAlert(true);
          setAlertType(alertData.type);
          setAlertTitle(alertData.title);
          return
      }
    
    const mailData: ISendMail = {
      toEmail: [staffConnect?.emailId ? staffConnect?.emailId : ""],
      subject: subject,
      content: content,
    };
    SendMail(mailData, setAlert);
    setIsLoading(true);
  };

  const onConfirm = () => {
    setShowAlert(false);
    setIsLoading(false);
    if (subject && content) {
      handleClose();
  }  
  };

  return (
    <>
      <div className="modal-body">
        <h2>Compose</h2>
        <p>
          Summarize your query briefly and send it to the chosen recipient. You
          can expect a reply within 24 hours.
        </p>

        <div className="emailform mt-3">
          <div className="label-to">
            <label htmlFor="">From</label>
            <div className="stude-details">
              <div className="img">
                <img src={baseURL && user?.image ? baseURL + user.image : ""} alt=""
                  onError={(e) => { e.currentTarget.src = "/assets/images/icon/DefaultImage.jpeg" }}
                />
              </div>
              <div className="desc">
                <h6>{user?.displayName}</h6>
                <p>
                  {user?.currentDepartment?.name} |{" "}
                  <span>{user?.currentCollege?.name}</span>
                </p>
              </div>
            </div>
          </div>
          <div className="label-to">
            <label htmlFor="">To</label>
            <div className="stude-details">
              <div className="img">
                <img
                  src={staffConnect?.image}
                  alt={staffConnect?.name}
                  onError={(e) => {
                    e.currentTarget.src =
                      "/assets/images/icon/DefaultImage.jpeg";
                  }}
                />
              </div>
              <div className="desc">
                <h6>{staffConnect?.name}</h6>
                <p>
                  {staffConnect?.department} |{" "}
                  <span>{staffConnect?.college}</span>
                </p>
              </div>
            </div>
          </div>
          <div className="formgroup">
            <label htmlFor="">Subject</label>
            <input
              type="text"
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>
          <div className="formgroup">
            <label htmlFor="">Message</label>
            <textarea
              name=""
              id="message"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="modal-footer mb-4">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSendMail}
        >
          Send
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleClose}
        >
          Cancel
        </button>
      </div>

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={showAlertCancel}
        onCancel={() => {
          setShowAlert(false);
          setShowAlertCancel(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
      ></SweetAlert>
      {isLoading && <LoaderSpinner />}
    </>
  );
};

const mapDispatchToProps = {
  SendMail: (Feedback: ISendMail, callback: Function) =>
    createFeedback(Feedback, callback),
};

function mapStateToProps(state: any) {
  return {
    user: state.userDetails.userProfileData,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StaffConnectCompose);
